import React from "react";
import { Routes, Route,Navigate} from "react-router-dom";
// import { Grid, Row, Col } from 'rsuite';

//Page
import Layout from "../js/Layout";
import Home from "../js/Home";
import HowOle from "../js/how_to_access_ole";
import Dashboard from "../js/Dashboard";
import CoursePage from "../js/CoursePage";
import TakingAttendance from "../js/TakingAttendance";
import Assignment from "../js/Assignment";
import ZoomRecording from "../js/ZoomRecording";
import TeachingTools from "../js/TeachingTools";

export default function RootRouter() {
    
    return (
        <Routes >
            <Route path=""  element={<Navigate replace={true} to="/" />} />
            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="Home" element={<Home />} />
                <Route path="how-to-access-ole" element={<HowOle />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="course-page" element={<CoursePage />} />
                <Route path="taking-attendance" element={<TakingAttendance />} />
                <Route path="assignment" element={<Assignment />} />
                <Route path="zoom-recording" element={<ZoomRecording />} />
                <Route path="teaching-tools" element={<TeachingTools />} />
                
                
            </Route>
            
            
            
            
            
        </Routes>  
    )
}
